const {ProductType} = require('@yandex-data-ui/cloud-schemas/build/models/marketplace');
const _isEmpty = require('lodash/isEmpty');
const _omit = require('lodash/omit');
const _isUndefined = require('lodash/isUndefined');
const _lowerCase = require('lodash/lowerCase');

const {Dashboard, DashboardTabs, DashboardTabValues, Sorting} = require('./constants');
const {serializeObject} = require('../utils');

const getQueryDashboardTabType = (tab) => {
    const availableDashboards = Object.keys(DashboardTabs);
    const queryType = availableDashboards.includes(tab) ? tab : availableDashboards[0];
    const queryDashboardTabType = DashboardTabs[queryType];

    return queryDashboardTabType;
};

function parseMktDashboardQuery(query) {
    const {tab, search, sortBy, ...other} = query;

    if (!query) {
        return {};
    }

    const queryDashboardTabType = getQueryDashboardTabType(tab);

    if (!isListRequest(query)) {
        return {
            type: queryDashboardTabType,
        };
    }

    const availableSorting = Object.values(Sorting);
    // Popularity sorting available only when field is empty TODO: fix later
    const querySortBy = availableSorting.includes(sortBy) ? sortBy : undefined;
    const queryAttributes = _isEmpty(other) ? undefined : serializeObject(other, ';');

    const resultQuery = {
        type: queryDashboardTabType,
        query: search,
        sortBy: querySortBy === Sorting.Default ? undefined : querySortBy,
        attributes: queryAttributes,
    };

    return _omit(resultQuery, _isUndefined);
}

function isListRequest(query) {
    if (!query) {
        return false;
    }

    const nonSearchQueries = ['sortBy', 'tab'];

    const otherQueries = Object.keys(query).filter((key) => !nonSearchQueries.includes(key));

    return otherQueries.length > 0;
}

function getProductType(type) {
    return Object.values(Dashboard).find((dashboardType) =>
        _lowerCase(type).includes(dashboardType),
    );
}

function getProductTypeForPrice(product) {
    const {type} = product;

    if (type === ProductType.K8s) {
        return Dashboard[type];
    }

    return getProductType(type);
}

function getMktProductUrl(id) {
    return `/marketplace/products/${id}`;
}

function getDashboardTab(type) {
    const DashboardTab = DashboardTabValues.find(({dashboardTypes}) =>
        dashboardTypes.includes(type),
    );
    return DashboardTab?.name;
}

module.exports = {
    parseMktDashboardQuery,
    getDashboardTab,
    isListRequest,
    getProductType,
    getMktProductUrl,
    getProductTypeForPrice,
};
